import contactsReducer from "./contacts";
import labelsReducer from "./labels";
import vesselsReducer from "./vessels";
import usersReducer from "./user";
import allUsersReducer from "./users";
import containersReducer from "./containers";
import containertypesReducer from "./containertype";
import fileReducer from "./files";
import terminalsReducer from "./terminals";
import tenantsReducer from "./tenants";
import terminalcallsReducer from "./terminalcall";
import notesReducer from "./notes";
import containerUploadReducer from "./containerupload";
import selectedContainerReducer from "./selectedcontainers";
import completedTerminalCallReducer from "./completedterminalcall";
import selectedTerminalCallReducer from "./selectedterminalcalls";
import filteredContainerReducer from "./filteredcontainers";
import voyageReducer from "./voyage";
import dialogReducer from "./dialog";
import modalReducer from "./modal";
import slideoutReducer from "./slideout";
import filterReducer from "./filter";
import mailsReducer from "./mails";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: {
    user: usersReducer,
    users: allUsersReducer,
    vessels: vesselsReducer,
    containers: containersReducer,
    containerTypes: containertypesReducer,
    files: fileReducer,
    terminals: terminalsReducer,
    tenants: tenantsReducer,
    terminalCalls: terminalcallsReducer,
    contacts: contactsReducer,
    labels: labelsReducer,
    dialog: dialogReducer,
    modal: modalReducer,
    slideout: slideoutReducer,
    notes: notesReducer,
    filter: filterReducer,
    containerUploads: containerUploadReducer,
    selectedContainers: selectedContainerReducer,
    completedTerminalCalls: completedTerminalCallReducer,
    voyages: voyageReducer,
    selectedTerminalCalls: selectedTerminalCallReducer,
    filteredContainers: filteredContainerReducer,
    mails: mailsReducer,
  },
});

export default store;
